module.exports = __webpack_public_path__ + "static/media/dairy.39466ca1.png";